import * as React from 'react'
import Text from '@eversports/klimt-primitives/Text'
import SeoLink from '@eversports/klimt-primitives/SeoLink'

import { Localized } from '../../localization/react'

import { AuthRoutes } from './UserMenu/UserMenu.constants'

interface Props {
  authUrlParams: string
}

// ACCESSIBILITY TODO - Color Contrast
const LoginButton = ({ authUrlParams }: Props) => (
  <SeoLink
    type="crawler"
    encodedTo={btoa(`${AuthRoutes.LOGIN}${authUrlParams}`)}
    crawlerLink={AuthRoutes.LOGIN}
    external
    buttonVariant="secondary"
  >
    <Text variant="small" sx={{ fontWeight: 'bold', color: 'primary.main', textTransform: 'none' }}>
      <Localized id="user-menu-item-login" />
    </Text>
  </SeoLink>
)

export default LoginButton
